import React from 'react';
import { baseXUnit } from '../../styles/theme';
import H from '../elements/H';
import IconText from '../common/IconText';
import { IconName } from '../common/Icon';
import Paragraph from '../elements/Paragraph';
import Spacing from '../common/Spacing';

interface TripContentElementProps {
  label: string;
  icon: IconName;
  textLines: string[];
  reassuringText: string;
}

const TripContentElement: React.FunctionComponent<
  TripContentElementProps & React.HTMLAttributes<HTMLElement>
> = ({ label, icon, textLines, reassuringText, ...rest }) => {
  return (
    <div className="trip-content-element" {...rest}>
      <div className="label">
        <H styling="h5" color="gray">
          {label}
        </H>
      </div>
      <IconText icon={icon} iconSize={3}>
        <H styling="h4" tag="div" data>
          {textLines.map((line) => (
            <div>{line}</div>
          ))}
        </H>
      </IconText>
      <Spacing left={4} top={[0.5, 0.5, 1]}>
        <Paragraph small>{reassuringText}</Paragraph>
      </Spacing>
      {/*language=CSS*/}
      <style jsx>{`
        .label {
          margin-left: ${baseXUnit(4)};
        }
      `}</style>
    </div>
  );
};

export default TripContentElement;
